import { styled } from "goober";

const List = styled("div")`
  display: grid;
  grid-template-columns: repeat(auto-fill, 216px);
  gap: 12px;
  padding: 24px;
`;

type Props = {
  children: React.ReactNode;
};

export function Directory({ children }: Props) {
  return <List>{children}</List>;
}
